import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToIntake } from "../../lib/erg";

export const ContextCTA = ({ label, micro, tone = "dark", testid }) => {
  const microColor = tone === "dark" ? "text-erg-dry/55" : "text-erg-ink/55";
  return (
    <div className="relative py-4 sm:py-8">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="flex flex-col items-center text-center gap-3">
          <button
            data-testid={testid}
            onClick={scrollToIntake}
            className="group inline-flex items-center gap-2 rounded-full bg-erg-ember px-7 py-3.5 sm:px-10 sm:py-5 font-display font-semibold uppercase tracking-wide text-erg-ink text-base sm:text-xl hover:brightness-105 active:scale-[0.98] transition-[transform,filter] duration-200 shadow-[0_10px_30px_-10px_rgba(224,138,60,0.7)]"
          >
            {label}
            <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-0.5 transition-transform duration-300" />
          </button>
          {micro && (
            <p className={`font-mono text-[12px] sm:text-sm tracking-wide ${microColor}`}>{micro}</p>
          )}
        </Reveal>
      </div>
    </div>
  );
};
